import wixData from 'wix-data';
import wixLocation from 'wix-location';
import wixWindow from 'wix-window';

$w.onReady(function () {
  //LOAD MORE ------------------------------------------------
  $w("#box1").onViewportEnter((event, $w) => {  //quando il box entra nella pagina
	  if($w("#speakerDataset").hasNextPage()){    //se nel dataset ci sono altri dati da mostrare
		  $w('#loadingText').show();                //mostra la scritta
      $w("#speakerDataset").loadMore().then(() => {  //carica altri dati dal dataset
	      $w('#loadingText').hide();              //nascondi la scritta
      });
	  }
  });

});

//...Barra di ricerca
export function ricercaNome_keyPress() {
let searchValue=$w("#ricercaNome").value;
$w("#speakerDataset").setFilter(wixData.filter().contains("name", searchValue));
wixWindow.scrollTo(0, 0);
}

//...tasto Reset
export function resetButton_click(event) {
//console.log("uso il tasto per Clear");
$w("#speakerDataset").setFilter(wixData.filter())
$w("#ricercaNome").value = null; // torna al testo placeholder
}

//...link di testo a una dynamic page - Titolo
export function titleText_click(event, $w) {
	//console.log("cerco l'evento nel dataset");
	let itemObj = $w("#speakerDataset").getCurrentItem(); //Getting the current item of the collection
   //redirect to the relevant dynamic page.
   //"link-Speakers-title" is the name of the field where the URL is saved
	wixLocation.to (itemObj["link-Speakers-title"]);
}